import { GetServerSideProps } from 'next'
import { ThemeContextProvider } from '@/contexts/ThemeContext'
import { NextPageWithLayout } from '@/layouts'
import { ContentOnlyLayout } from '@/layouts/ContentOnlyLayout'
import { getLocaleFromParams } from '@/utils/LocaleUtil'
import { getServerSidePropsErrorHandler, getUrlFromThisFilePath } from '@/utils/nextUtils/nextErrorHandlers'
import { loadTranslations } from '@/utils/translate/translate-server'
import { getUserGuildStatus, getUserUuidFromJwt } from '@/utils/users/usersServer'
import { SignUpPickerView } from '@/views/SignUpPickerView'

export const SignUpHome: NextPageWithLayout = () => {
  return (
    <ThemeContextProvider isDarkMode>
      <SignUpPickerView />
    </ThemeContextProvider>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ req, res, params }) =>
  getServerSidePropsErrorHandler({ requestUrl: getUrlFromThisFilePath(params) }, async () => {
    const locale = getLocaleFromParams(params)
    const uuid = getUserUuidFromJwt(req, res) ?? null
    const guildStatus = !uuid ? false : await getUserGuildStatus(uuid)

    if (guildStatus && guildStatus.isGuildMember) {
      return {
        redirect: {
          destination: '/guild',
          permanent: false,
        },
      }
    }

    return {
      props: {
        locale,
        ...(await loadTranslations(locale, ['common', 'sign-up'])),
      },
    }
  })

SignUpHome.getLayout = (page) => {
  return <ContentOnlyLayout>{page}</ContentOnlyLayout>
}

export default SignUpHome
